import React, { Component } from "react";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Axios from "../../../config/axios";
import { Row, Table, Tooltip, Button, Modal } from "antd";
import searchColumns from "../../../helpers/searchColumns";

const moment = require("moment");

class RejectedLetters extends Component {
  state = {
    letters: [],
    page: 1,
    pageSize: 20,
    pagination: {},
    searchText: "",
    searchedColumn: "",
    rejectedModal: false,
    unit: "",
  };

  componentDidMount() {
    this.checkUnit();
  }

  checkUnit = () => {
    this.setState({ unit: this.props.user.info.unit_id }, () =>
      this.fetchLetters()
    );
  };

  fetchLetters = (filters = {}, sorter = {}) => {
    let params = {};
    // if(filters.letters_type) params.letters_type = filters.letters_type[0]
    if (filters.requester) params.requester = filters.requester[0];
    if (sorter.field && sorter.order) {
      params.sort_field = sorter.field;
      params.sort_order = sorter.order === "ascend" ? 1 : -1;
    }

    if (this.props.user.info.type === "operator") {
      params.faculty_id = this.state.unit;
    }

    if (this.props.user.info.type === "prodi") {
      params.major_id = this.state.unit;
    }

    Axios.get("/requested-letters", {
      params: {
        page: this.state.page,
        step: "rejected",
        page_size: this.state.pageSize,
        ...params,
      },
    }).then((response) => {
      let { pagination } = this.state;
      pagination.total = response.data.total;
      pagination.pageSize = this.state.pageSize;
      this.setState({ letters: response.data.payload, pagination });
    });
  };

  handleChangeTable = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState(
      {
        pagination: pager,
        page: pager.current,
      },
      () => {
        this.fetchLetters(filters, sorter);
      }
    );
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  showRejectedReason = (text) => {
    this.toggleRejectedModal();
    this.setState({ rejectedReason: text });
  };

  toggleRejectedModal = () => {
    this.setState({ rejectedModal: !this.state.rejectedModal });
  };

  render() {
    const columns = [
      {
        title: "NIM",
        dataIndex: "requester",
        sorter: true,
        ...searchColumns(
          "requester",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText
        ),
      },
      {
        title: "Jenis Surat",
        dataIndex: "letters_name",
        sorter: true,
        // ...searchColumns('', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      // {
      //     title: 'Tipe Surat',
      //     dataIndex: 'letters_type',
      //     sorter: true,
      //     filters: [
      //         { text: 'Akademik', value: 'akademik' },
      //         { text: 'Kemahasiswaan', value: 'kemahasiswaan' },
      //     ],
      //     filterMultiple: false,
      //     render: type => {
      //         const colors = {
      //             akademik : 'blue',
      //             kemahasiswaan : 'green',
      //         }
      //         return <Tag color={colors[type]}>{type.toUpperCase()}</Tag>
      //     }
      // } ,
      {
        title: "Tanggal Ditolak",
        dataIndex: "rejected_date",
        sorter: true,
        render: (text) => (text ? moment(text).format("LLL") : "-"),
        // ...searchColumns('requester', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      {
        title: "",
        dataIndex: "rejected_reason",
        render: (text) => (
          <>
            <Tooltip title="Alasan Ditolak" className="m-2">
              <Button
                shape="round"
                onClick={() => this.showRejectedReason(text)}
              >
                Alasan Ditolak
              </Button>
            </Tooltip>
          </>
        ),
      },
    ];

    return (
      <>
        <Row style={{ padding: 10 }}>
          <Table
            rowKey="_id"
            style={{ width: "100%" }}
            columns={columns}
            dataSource={this.state.letters}
            loading={this.props.loading}
            pagination={this.state.pagination}
            onChange={this.handleChangeTable}
          />
        </Row>

        <Modal
          visible={this.state.rejectedModal}
          footer={null}
          title="Alasan Ditolak"
          onCancel={this.toggleRejectedModal}
        >
          <p>{this.state.rejectedReason}</p>
        </Modal>
      </>
    );
  }
}

export default withErrorHandler(RejectedLetters, Axios);
